import { Box, Stack } from "@biblioteksentralen/react";
import { FrontPageData } from "../../app/[locale]/sites/[siteDomain]/page";
import { DefaultContainer } from "../ContentContainer";
import AlertBanner from "./banners/alert/AlertBanner";
import BookListBanner from "./banners/BookListBanner";
import EventsBanner from "./banners/events/EventsBanner";
import { LibrariesBanner } from "./banners/LibrariesBanner";
import { OpeningHoursBanner } from "./banners/openingHours/OpeningHoursBanner";
import { useFeaturedBanners } from "./banners/promotedItems/FeaturedBanner";
import { ReactNode } from "react";
import { useCommonData } from "../layout/CommonDataProvider";
import { ServicesAndDigitalServicesBanners } from "./banners/ServicesAndDigitalServicesBanner";
import { useTranslation } from "../../utils/hooks/useTranslation";

/**
 * NOTE: Update docs when making changes: https://bs-redia.atlassian.net/l/cp/e54CX5CS
 */
export function SiteView(props: FrontPageData & { kulturfondBrowser: ReactNode }) {
  const { firstFeaturedBanner, secondFeaturedBanner, removeFeaturedItems } = useFeaturedBanners(props);
  const { site } = useCommonData();
  const { t } = useTranslation();

  const firstThreeItems = removeFeaturedItems(props.listsAndRecommendations).slice(0, 3);
  const nextThreeItems = removeFeaturedItems(props.listsAndRecommendations).slice(3, 6);

  return (
    <Box marginBottom={{ base: "2rem", md: "4rem" }} marginTop={{ md: "1rem", lg: "2rem" }}>
      <AlertBanner alert={props.alert} marginBottom={{ base: "2rem", lg: "3rem" }} />
      <Stack direction="column" gap={{ base: "3rem", lg: "5rem" }}>
        {firstFeaturedBanner}
        <OpeningHoursBanner libraries={props.libraries} />
        {secondFeaturedBanner}
        <EventsBanner events={props.events} />
        {site?.hideExternalContent ? (
          <BookListBanner listAndRecommendations={firstThreeItems} />
        ) : (
          <DefaultContainer>{props.kulturfondBrowser}</DefaultContainer>
        )}
        <ServicesAndDigitalServicesBanners
          heading={t("Utforsk tilbudet vårt")}
          orientation="column"
          digitalLibraryServices={props.digitalLibraryServices}
        />
        <BookListBanner listAndRecommendations={!site?.hideExternalContent ? firstThreeItems : nextThreeItems} />
        <LibrariesBanner libraries={props.libraries} />
      </Stack>
    </Box>
  );
}
